import { useEffect, useRef } from 'react'
import { useAppSelector } from '@/app/hooks'
import { fileTokenService } from '@/lib/services/fileTokenService'
import { getStorageItem, STORAGE_KEYS } from '@/lib/utils/storage'

/**
 * Component to initialize file token service on app startup
 * Starts auto-refresh when user is authenticated.
 * Only clears file token on explicit logout (transition from authenticated to not),
 * not on initial load/refresh when isAuthenticated may be false before rehydration.
 */
export function FileTokenInitializer() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated)
  const wasAuthenticatedRef = useRef<boolean | null>(null)

  useEffect(() => {
    const authToken = getStorageItem(STORAGE_KEYS.authToken)

    if (isAuthenticated && authToken) {
      wasAuthenticatedRef.current = true
      fileTokenService.startAutoRefresh()
    } else {
      // Only clear file token when user has explicitly logged out (was true, now false).
      // Do not clear on initial mount/refresh when isAuthenticated is false before rehydration.
      if (wasAuthenticatedRef.current === true) {
        fileTokenService.stopAutoRefresh()
        fileTokenService.clearFileAccessToken()
        wasAuthenticatedRef.current = false
      } else if (wasAuthenticatedRef.current === null) {
        wasAuthenticatedRef.current = false
      }
      fileTokenService.stopAutoRefresh()
    }
  }, [isAuthenticated])

  return null
}

